import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  appBar: {
    marginBottom: '2rem',
  },
  links: {
    flexGrow: 1,
  },
  link: {
    color: '#fff',
  },
  user: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '1rem',
    '& > *': {
      margin: theme.spacing(0.5),
    },
  },
  avatar: {
    color: theme.palette.primary.main,
    backgroundColor: '#fff',
  },
}))
export default useStyles
